import React from 'react'
import { BgShadow } from '.'

const Shadows = () => {
    return (
        <div className=' absolute left-0 top-0 w-full h-full'>
            <div className=' flex items-center justify-between'>
                <div className=''>
                    <BgShadow color1='text-dynamic' color2="text-dynamic" />
                </div>
                <div className=' opacity-25'>
                    <BgShadow color1='text-dynamic' color2="text-dynamic" />
                </div>
                <div className=' opacity-75'>
                    <BgShadow color1='text-dynamic' color2="text-dynamic" />
                </div>
            </div>
            <div className=' flex items-center justify-end flex-1'>
                <div className=' opacity-25'>
                    <BgShadow color1='text-dynamic' color2="text-dynamic" />
                </div>
            </div>
        </div>
    )
}

export default Shadows
